var remove_active = function(elem)
{
  let items = document.querySelectorAll(elem);
    items.forEach(function(item) {
      item.classList.remove('active');
    });
  
}

var expand_form = function()
{
  	document.getElementById('formextra').classList.add('active');
}
document.getElementById('drip-email').onclick = expand_form;

jQuery(function($){
  /*const swiperBeers = new Swiper("#shopify-section-template--21934718812456__image_gallery_mynkTc .swiper", {
      slidesPerView: 5,
      spaceBetween: 10,
      freeMode: true,
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      breakpoints: {
          320: {
              slidesPerView: 1,
          },
          800: {
              slidesPerView: 2,
          },
          1200: {
              slidesPerView: 3,
          },
          1500: {
              slidesPerView: 4,
          },
          1700: {
              slidesPerView: 5
          },
          2200: {
              slidesPerView: 6
          },
      },
  });*/
  $('#shopify-section-template--21934718812456__image_gallery_mynkTc .image-bar').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('#shopify-section-template--23687729479976__image_test_43gAmA .image-bar').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },

      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  jQuery('.taproom-menu a').on('click', function(e){
    e.preventDefault();
    jQuery('.taproom-menu a').removeClass('selected');
    jQuery(this).addClass('selected');
    jQuery('#shopify-section-template--23687729479976__advanced_layout_custom_html_zNfpEX').hide();
    jQuery('#shopify-section-template--23687729479976__advanced_layout_custom_html_dCktHU').hide();
    jQuery(jQuery(this).attr('href')).show();
  });

  jQuery('.awards-menu a').on('click', function(e){
    e.preventDefault();
    jQuery('.awards-menu a').removeClass('selected');
    jQuery(this).addClass('selected');
    jQuery('#shopify-section-template--23692329812264__advanced_layout_custom_html_zNfpEX').hide();
    jQuery('#shopify-section-template--23692329812264__advanced_layout_custom_html_dCktHU').hide();
    jQuery('#shopify-section-template--23692329812264__advanced_layout_custom_html_gQiGm3').hide();
    jQuery(jQuery(this).attr('href')).show();
  });

  if( jQuery('#bShipping').length ){
    jQuery('#bShipping').on('click', function(){
      let id = $(this).attr('href');
      jQuery('.product-link-text').removeClass('active');
      jQuery(id).addClass('active');
    });
  } 
    jQuery('#bShipping-fr').on('click', function(){
      let id = $(this).attr('href');
      jQuery('.product-link-text').removeClass('active');
      jQuery(id).addClass('active');
    });

  if( jQuery('#bFaq').length ){
    jQuery('#bFaq').on('click', function(){
      let id = $(this).attr('href');
      jQuery('.product-link-text').removeClass('active');
      jQuery(id).addClass('active');
    });
  }


  jQuery('.faq-cols dl dt').on('click', function(){
    jQuery(this).parent().find('dd').slideToggle();
  });


  const pastGalleryDiv = $('<div class="row image-bar"></div>'); 
  $('#past-beers .homepage-section--image-gallery-wrapper').each(function() {
    pastGalleryDiv.append($(this).contents());
    $(this).remove();
  });
  $('.past-beers-gallery').append(pastGalleryDiv);

});